import {Settings} from 'app/pages/settings/Settings'
import SuspensedView from 'common/components/SuspensedView'
import {FC, lazy} from 'react'
import {Navigate, Route, Routes} from 'react-router'

import {MasterLayout} from '_metronic/layout/MasterLayout'

const ProfilePage = lazy(() => import('app/pages/common/profile/ProfilePage'))
const WizardsPage = lazy(() => import('app/modules/wizards/WizardsPage'))
const AccountPage = lazy(() => import('app/modules/accounts/AccountPage'))
const WidgetsPage = lazy(() => import('app/modules/widgets/WidgetsPage'))
const UsersPage = lazy(() => import('app/modules/apps/user-management/UsersPage'))

const Dashboard = lazy(() => import('app/pages/client/dashboard/Dashboard'))

const ClientRoutes: FC = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route
          path='dashboard'
          element={
            <SuspensedView>
              <Dashboard />
            </SuspensedView>
          }
        />

        <Route
          path='settings'
          element={
            <SuspensedView>
              <Settings />
            </SuspensedView>
          }
        />

        <Route
          path='profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export default ClientRoutes
